import { render } from "./NavbarSection.vue?vue&type=template&id=22d5b5e9&scoped=true"
import script from "./NavbarSection.vue?vue&type=script&lang=js"
export * from "./NavbarSection.vue?vue&type=script&lang=js"

import "./NavbarSection.vue?vue&type=style&index=0&id=22d5b5e9&lang=scss&scoped=true"

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-7c0eacfc91/0/cache/vue-loader-npm-17.4.2-00674d01e5-2b5a15858e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d5b5e9"]])

export default __exports__